import { render, staticRenderFns } from "./privateequityjapan.vue?vue&type=template&id=0e670143"
import script from "./privateequityjapan.vue?vue&type=script&lang=js"
export * from "./privateequityjapan.vue?vue&type=script&lang=js"
import style0 from "./privateequityjapan.vue?vue&type=style&index=0&id=0e670143&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports